<template>
	<div>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="132.7px"
	 height="177.3px" viewBox="0 0 132.7 177.3" style="enable-background:new 0 0 132.7 177.3;" xml:space="preserve">
<g id="boton1" @click="evaluar()">
	<g>
			<image style="overflow:visible;" width="119" height="119" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAB3CAYAAAA5Od+KAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ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" transform="matrix(1 0 0 1 6.8335 7.2808)">
		</image>
		<g id="XMLID_2790_">
			<rect id="XMLID_11_" x="10.6" y="140.4" class="st3" width="111.5" height="29.5"/>
			<text transform="matrix(1 0 0 1 52.9458 152.436)" class="st2 st1 st4">Gas </text>
		</g>
		<linearGradient id="XMLID_3_" gradientUnits="userSpaceOnUse" x1="4.4214" y1="66.7808" x2="128.2456" y2="66.7808">
			<stop  offset="0" style="stop-color:#23CAD9"/>
			<stop  offset="0.9898" style="stop-color:#32ADF0"/>
		</linearGradient>
		<circle id="XMLID_2618_" class="st0" cx="66.3" cy="66.8" r="59.4"/>
	</g>
</g>
<g id="check1" :class="visto ?'mostrar':'esconder'">
	
		<image style="overflow:visible;" width="26" height="26" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJ
bWFnZVJlYWR5ccllPAAAAsVJREFUeNpiYKATYCRGkeTcIAUgFcDwn0EfSCsgSX0AmnARSG94nrzu
AtkWycwPMvj/n6EebAlh8ICRkaHxSeK6BSRZJLsgqB9IFZARSgeAFgY+il/3Aa9FCouDBIC+WA9k
OlAQJR+Aljk+iEUEJxO6CiZGhvnMTAwOQMxAARYAmrNfaWmwAMxcFmRLVJYFNxAZH8QAkCWgkHFE
CTq1lcEKwFR1HqqAJMDLys3Ax8bN8PTrK2zSibci1i5gQgqyfCaQl4EipOJO82yGje7dDFpCCtjk
61F8pLUm+D05vmk1yWEIkIekm8+/vzJ0XFzAsOHhfnRlhuA40lkX7ECOJf5yjnBLYEHICPUJGggA
WwSUMCDVEkdJM4YW42wUsaX3tjJsfrwfm0X2MItI8o06nwJDsyGqJZsfH2DouTofmyWIfIQvT4CC
p8kwB87nZ+dmmG3VCA4mGLj16QFD7/X5eM2B+Qgr8JZ2ZKjXy4YXIX035jPMMEO15Pn31wwZp+oZ
vv39itMceIYFKniALqHKqwC3BAR8ZBwY7CVMGXhZEJZ8+fOVofx8J0FLQEUSE9SiC+jp/+7XBwzb
nh1AzZhIloBAxYUuhjtAdUTktYPwfGS9J/g+Wl0DBmFy3gx5qokYTmy7NpVh2/P9xKYfQ0TJwMSw
EFskrn2ylaH9xlQUXauBYjtf7ieqgAWae+Coy9oLyEXQBGBm+4DN67uAhnbchFi24+UBhml355NS
RDVi1EeOh4IDGCElLlZgLWzGcOHjVYavwERADPjPwLBgv93aRKwVn/ORkH5G8mpWdEsuMPz/77jX
du0HnFW527EQcqtxGLgArKUdd1uv+UCwzeB+PCQAWB3PJ6OwnbDDYk0hSa0gz5MhAkDLQD6Lx5b0
0cACoC8at5uveUB2uw5cMpwOMQA3WBjRfPifAZSrL2wxXfMBn36AAAMAZz7LJ6pPpnwAAAAASUVO
RK5CYII=" transform="matrix(1 0 0 1 96.7456 10.9995)">
	</image>
</g>
</svg>
		<modal-app v-model="modala" :fullscreen="false" width="700px">
			<template slot="modaltittle">
			</template>

			<template slot="modalcontent">
				<v-layout row wrap justify-center align-center>
					<v-flex xs12 md6>
						<img class="img-fluid" src="@/assets/unidad1/pantalla-4-2.png" alt="">
					</v-flex>
					<v-flex xs12 md6>
						<h2>Gas</h2>
						<p>Estado de la materia en el cual, bajo ciertas condiciones de temperatura y presión, las
							moléculas de una sustancia interaccionan débilmente entre sí, adoptando la forma y el
							volumen del recipiente que las contiene y tienden a separarse (expansión).</p>
					</v-flex>
				</v-layout>
			</template>
		</modal-app>
	</div>
</template>

<script>
	import nextConditions from "../../../js/mixins/nextConditions";
	export default {
		mixins: [nextConditions],
		data() {
			return {
				modala: false,
				visto: false,
			}
		},
		methods: {
			evaluar() {
				this.modala = true;
				this.visto = true;
				this.$store.commit('vistosUnidad1Mod31', this.visto)
				if (this.$store.state.vistosUnidad1Mod31 && this.$store.state.vistosUnidad1Mod32 && this.$store.state
					.vistosUnidad1Mod33 && this.$store.state.vistosUnidad1Mod34) {
					this.$store.commit('vistosAllMod3', true)
				}
			}
		},
		mounted() {},
	}
</script>


<style lang="scss" scoped>
	svg {
		cursor: pointer;
	}

	.mostrar {
		display: block;
	}

	.esconder {
		display: none;
	}

	.st0{fill:none;stroke:url(#XMLID_3_);stroke-width:5;stroke-miterlimit:10;}
	.st1{font-family:'FontBase-SemiBoldItalic';}
	.st2{fill:#2D2D2D;}
	.st3{fill:none;}
	.st4{font-size:17;}
</style>